module.exports = __webpack_public_path__ + "assets/next.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/next.svg
// module id = 355
// module chunks = 0